export function errorMessage(code, customer, creditCard) {
    let message;

    switch (code) {
        case '106':
            message = 'Não foi possível finalizar seu pagamento';
            break;
        case '109':
            message =
                'O cartão informado não suporta pagamentos em ' +
                creditCard.installments +
                ' parcelas. Utilize outro cartão ou outro meio de pagamento';
            break;
        case '126':
            message = 'Não foi possível processar seu pagamento';
            break;
        case '129':
            message =
                'O cartão informado não suporta pagamentos nesse valor. Utilize outro cartão ou outro meio de pagamento';
            break;
        case '145':
            message = 'Não foi possível processar seu pagamento';
            break;
        case '150':
            message = 'Você não pode realizar pagamentos no momento';
            break;
        case '151':
            message = 'Você não pode realizar pagamentos com esse cartão no momento';
            break;
        case '160':
            message = 'Cobrador não habilitado a operar';
            break;
        case '204':
            message = 'Digite o seu número de cartão';
            break;
        case '205':
            message = 'Digite o seu número de cartão';
            break;
        case '208':
            message = 'Escolha um mês';
            break;
        case '209':
            message = 'Escolha um ano';
            break;
        case '212':
        case '213':
        case '214':
            message = 'Insira o seu documento';
            break;
        case '220':
            message = 'Digite o seu banco emissor';
            break;
        case '221':
            message = 'Ditite o seu nome como está no cartão';
            break;
        case '224':
            message = 'Digite o código de segurança';
            break;
        case 'E301':
            message = 'Por favor, verifique o número do seu cartão';
            break;
        case 'E302':
            message = 'Verifique se o código de segurança digitado está correto';
            break;
        case '316':
            message = 'Insira um nome válido';
            break;
        case '322':
        case '323':
        case '324':
            message = customer.doc_type.toUpperCase() + ' inválido';
            break;
        case '325':
            message = 'Verifique a data de validade do cartão';
            break;
        case '326':
            message = 'Verifique a data de validade do cartão';
            break;
        case '801':
            message =
                'Você realizou um pagamento similar há pouco tempo. Tente novamente em alguns minutos';
            break;
        default:
            message = 'Falha na validação do cartão';
    }

    return message;
}
